import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import file from "../../../assets/files/file.docx";
import AppBreadcrumb from "../../../components/template/BreadCrumb/AppBreadcrumb";
import MetaInformation from "../../../utils/meta/MetaInformation";
import { findActiveTab } from "./findActiveTab";
import "./AccessoriesInfo.scss";

const AccessoriesInfo = () => {
  const [activeTab, setActiveTab] = useState("description");
  const [activeAccessory, setActiveAccessory] = useState([]);
  const location = useLocation().state;

  const params = useParams().id;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    setActiveTab("description");
    if (location.from === "accessories") {
      setActiveAccessory(
        location.filteredArray[0].instruments.filter(
          (state) => state.title === location.title
        )
      );
    } else {
      setActiveAccessory(
        location.filteredArray.filter((state) => state.title === location.title)
      );
    }
  }, [params]);

  const activeHandler = (event) => {
    setActiveTab(findActiveTab(event.target.innerText));
  };

  const description = (state) => {
    if (params === "piston-type-regulators") {
      return (
        <>
          <p className="mt-3">{state.description?.describe}</p>
          <h6>
            {state.description?.heading?.heading1}
            <p>{state.description?.heading?.value1}</p>
          </h6>
          <h6>
            {state.description?.heading?.heading2}
            <p>{state.description?.heading?.value2}</p>
          </h6>
          <h6>
            {state.description?.heading?.heading3}
            <p>{state.description?.heading?.value3}</p>
          </h6>
        </>
      );
    } else if (
      params === "critical-area-bed-head-units" ||
      params === "patient-bed-head-units" ||
      params === "surgery-pendant-scentric"
    ) {
      return (
        <>
          <p className="mt-3">{state.description?.describe}</p>
          <ul className="mt-3">
            {state.description?.list1?.map((state, index) => (
              <li key={index}>{state}</li>
            ))}
          </ul>
        </>
      );
    } else {
      return (
        <>
          {Array.isArray(state.description) &&
            state.description?.map((state, index) => (
              <p className={index === 0 ? "mt-3" : ""} key={index}>
                {state}
              </p>
            ))}
        </>
      );
    }
  };
  const characteristics = (state) => {
    if (
      params === "piston-type-regulators" ||
      params === "diaphragm-type-regulators" ||
      params === "vacuum-regulator-american" ||
      params === "vacuum-regulator-european"
    ) {
      return (
        <>
          <p className="mt-3">{state.characteristics?.charac}</p>
          <h6>{state.characteristics?.heading1}</h6>
          <ul className="mt-2">
            {state.characteristics?.list1?.map((state, index) => (
              <li key={index}>{state}</li>
            ))}
          </ul>
          <h6>{state.characteristics?.heading2}</h6>
          <ul className="mt-2">
            {state.characteristics?.list2?.map((state, index) => (
              <li key={index}>{state}</li>
            ))}
          </ul>
        </>
      );
    } else {
      return (
        <ul className="mt-3">
          {state.characteristics?.map((state, index) => (
            <li key={index}>{state}</li>
          ))}
        </ul>
      );
    }
  };
  // Commented parts are changed after the new design, although it was in the previous design

  return (
    <>
      <MetaInformation
        title={`${location.title} - HERZMANN`}
        name="Accessory info route"
        content={`Showing details of ${location.title}`}
      />
      <AppBreadcrumb />
      <main className="Single_Accessories_Main">
        {activeAccessory?.map((state, index) => {
          return (
            <Container fluid="lg" key={index}>
              <Row>
                <Col className="p-3">
                  <article>
                    <div className="d-flex justify-content-center flex-row gap-3 flex-md-column align-items-start">
                      <Card className="d-flex justify-content-center align-items-center">
                        <img
                          src={state.image}
                          alt={`${state.title} image`}
                          className={
                            params === "critical-area-bed-head-units" ||
                            params === "patient-bed-head-units"
                              ? "bed-units"
                              : ""
                          }
                        />
                      </Card>
                    </div>
                    <div>
                      <h4>{state.title}</h4>
                      <p>{state.working}</p>
                      {/* file shoulbe be import and its name should be added as to={file-name} or url should be placed in to for download */}
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        to={file}
                        download
                      >
                        Download
                      </Link>
                    </div>
                  </article>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col className="p-3">
                  <span>
                    <button
                      value="description"
                      className={activeTab === "description" ? "Active" : ""}
                      onClick={activeHandler}
                    >
                      Description
                    </button>
                    <button
                      value="characteristics"
                      className={
                        activeTab === "characteristics" ? "Active" : ""
                      }
                      onClick={activeHandler}
                    >
                      Characteristics
                    </button>
                  </span>

                  {activeTab === "description" && description(state)}
                  {activeTab === "characteristics" && characteristics(state)}
                </Col>
              </Row>
            </Container>
          );
        })}
      </main>
    </>
  );
};

export default AccessoriesInfo;
